const ImageCopyLinkIcon = () => {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.9 12.5C3.9 10.79 5.29 9.4 7 9.4H11V7.5H7C4.24 7.5 2 9.74 2 12.5C2 15.26 4.24 17.5 7 17.5H11V15.6H7C5.29 15.6 3.9 14.21 3.9 12.5ZM8 13.5H16V11.5H8V13.5ZM17 7.5H13V9.4H17C18.71 9.4 20.1 10.79 20.1 12.5C20.1 14.21 18.71 15.6 17 15.6H13V17.5H17C19.76 17.5 22 15.26 22 12.5C22 9.74 19.76 7.5 17 7.5Z"
				fill="#00666E"
			/>
		</svg>
	);
};

export default ImageCopyLinkIcon;
